<template>
  <div class="flex flex-col justify-between w-full">
    <template v-if="$mq === 'sm'">
      <work-order-cell
        :work-order="workOrder"
        :key="`work_order_${i}`"
        v-for="(workOrder, i) in workOrders"
      />
    </template>
    <bdg-table-view
      class="contract-work-orders-table-view"
      :rows="workOrders"
      :columns="columns"
    >
      <template #beside-pagination>
        <bdg-button
          class="ghost has-icon w-full md:w-auto uppercase"
          before-icon-class="fal fa-plus-square"
          @click.native="addWorkOrder"
        >
          add work order
        </bdg-button>
      </template>
    </bdg-table-view>
  </div>
</template>

<script>
import BdgButton from "../../elements/BdgButton";
import BdgTableView from "../../elements/table-view/BdgTableView";
import WorkOrderCell from "../../elements/list-view/list-view-cells/contract-cells/WorkOrderCell";
import MultiLabelTextCell from "../../elements/table-view/special-cells/MultiLabelTextCell";
import FilesListCell from "../../elements/table-view/special-cells/FilesListCell";
import IconTextCell from "../../elements/table-view/special-cells/IconTextCell";
import AddressCell from "../../elements/table-view/special-cells/AddressCell";
import WorkOrderForm from "./forms/WorkOrderForm";
import { CompletionStatusIcons } from "../../js-data/icon-maps";
import { CompletionStatusLabels } from "../../constants/enums";
import GenericDeleteModal from "../../components/modals/GenericDeleteModal";

export default {
  name: "ContractWorkOrders",
  components: { WorkOrderCell, BdgTableView, BdgButton },
  data() {
    return {
      contractId: parseInt(this.$route.params.id, 10),
      columns: [
        { label: "Work Order", property: "title" },
        {
          label: "Hours",
          property: "hoursLabelsAndTexts",
          cellComponent: MultiLabelTextCell,
          additionalCellClasses: "capitalize"
        },
        { label: "Assigned To", property: "userName" },
        {
          label: "Customer & Location",
          property: "contact",
          cellComponent: AddressCell
        },
        {
          label: "Attached Images",
          property: "nestedFiles",
          cellComponent: FilesListCell
        },
        {
          label: "Present",
          property: "presentLabelsAndTexts",
          cellComponent: MultiLabelTextCell
        },
        {
          label: "Status",
          property: "statusWithIcon",
          cellComponent: IconTextCell,
          additionalCellClasses: "w-px whitespace-no-wrap"
        },
        {
          label: "Actions",
          property: "actions",
          actions: [
            {
              label: "PDF",
              clickAction: workOrder => {
                this.$store.dispatch("getPdfUrl", {
                  type: "work-order",
                  type_id: workOrder.id
                });
              }
            },
            {
              label: "edit",
              clickAction: workOrder => {
                this.$store.commit("setCreateEditComponentParams", {
                  createEditComponent: WorkOrderForm,
                  createEditComponentData: workOrder,
                  createEditComponentIsShown: true
                });
              }
            },
            {
              label: "delete",
              clickAction: workOrder => {
                this.$store.commit("setConfirmationModalParams", {
                  type: "delete",
                  headerText: "Delete Confirmation",
                  bodyComponent: GenericDeleteModal,
                  bodyComponentData: {
                    entityName: "work order",
                    deleteFunction: () =>
                      this.$store.dispatch("deleteWorkOrder", workOrder)
                  },
                  isShown: true
                });
              }
            }
          ],
          additionalCellClasses: "w-px whitespace-no-wrap"
        }
      ]
    };
  },
  computed: {
    contract() {
      return this.$store.state.Contracts.contract;
    },
    workOrders() {
      const workOrders = this.$store.state.Contracts.WorkOrders
        .contractWorkOrders;
      if (workOrders) {
        return workOrders
          .sort((a, b) => a.title.localeCompare(b.title))
          .map(workOrder => {
            workOrder.nestedFiles = {
              files: workOrder.files.map(f => {
                return {
                  ...f,
                  viewClickAction: () => {
                    const win = window.open(f.url);
                    win.focus();
                  },
                  deleteClickAction: () => {
                    const formData = Object.assign({}, workOrder);
                    delete formData.nestedFiles;
                    formData.files.splice(workOrder.files.indexOf(f), 1);

                    this.$store.dispatch("updateWorkOrder", formData);
                  }
                };
              })
            };

            workOrder.statusWithIcon = {
              text: CompletionStatusLabels[workOrder.status],
              iconClasses: `${
                CompletionStatusIcons[workOrder.status]
              } text-xl text-dark-gray`
            };

            switch (workOrder.status) {
              case "not started":
                workOrder.statusWithIcon.iconClasses =
                  "far fa-play-circle fa-fw";
                break;
              case "in progress":
                workOrder.statusWithIcon.iconClasses = "fas fa-circle fa-fw";
                break;
              case "completed":
                workOrder.statusWithIcon.iconClasses = "fas fa-check fa-fw";
            }

            return workOrder;
          });
      }
      return workOrders;
    }
  },
  created() {
    this.$store.dispatch("getContractWorkOrders", this.contractId);
  },
  methods: {
    addWorkOrder() {
      this.$store.commit("setCreateEditComponentParams", {
        createEditComponent: WorkOrderForm,
        createEditComponentData: {
          contact_id: this.contract.primary_contact_id
        },
        createEditComponentIsShown: true
      });
    }
  }
};
</script>
